import script from "./StartPage.vue?vue&type=script&setup=true&lang=js"
export * from "./StartPage.vue?vue&type=script&setup=true&lang=js"

import "./StartPage.vue?vue&type=style&index=0&id=0804fd6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0804fd6e"]])

export default __exports__